import { Helmet } from 'react-helmet-async'

export function LocalBusinessJsonLd() {
  const json = {
    '@context': 'https://schema.org',
    '@type': 'MedicalBusiness',
    name: 'Raintree Chinese Medicine and Acupuncture',
    description:
      "Holistic Chinese medicine clinic specializing in women's health and wellbeing, offering acupuncture, herbal medicine, and fertility support.",
    url: 'https://raintreechinesemedicine.com.au',
    telephone: '+61752409192',
    email: 'renee@raintreechinesemedicine.com.au',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '31 Burgess Drive',
      addressLocality: 'Tewantin',
      addressRegion: 'QLD',
      postalCode: '4565',
      addressCountry: 'AU',
    },
    geo: { '@type': 'GeoCoordinates', latitude: -26.406375885009766, longitude: 153.02626037597656 },
    openingHours: ['Mo 09:00-17:00', 'We 09:00-17:00', 'Fr 09:00-17:00'],
    priceRange: '$$',
    medicalSpecialty: [
      'Chinese Medicine',
      'Acupuncture',
      "Women's Health",
      'Fertility Treatment',
      'Pregnancy Care',
      'Menopause Treatment',
    ],
    founder: {
      '@type': 'Person',
      name: 'Renee Knott',
      jobTitle: 'Acupuncturist and Chinese Medicine Herbalist',
      description: 'APHRA registered Acupuncturist and Chinese Medicine Herbalist with 20 years of clinical experience',
    },
    areaServed: ['Noosa', 'Noosa Heads', 'Noosaville', 'Tewantin', 'Sunshine Coast'],
  }

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(json)}</script>
    </Helmet>
  )
}


